module.exports = __webpack_public_path__ + "img/page.a9b16e30.png";